import React, {useEffect, useState} from "react"
import styled from 'styled-components'
import { useAppSelector } from "../../redux/hooks"
import { selectOpen } from "../ducks/navigationSlice"
import _ from 'lodash'
//@ts-ignore
import AssetDashboard from 'plugin-liverig/shared/asset/components/dashboards/AssetDashboard'

interface DashboardRendererProps {

}

const DashboardRenderer: React.FC<DashboardRendererProps> = ({  }) => {
    const open = useAppSelector((state) => selectOpen(state))

    useEffect(() => {
        try {
            _.debounce(() => {
                    window.dispatchEvent(new Event('resize'));
                }, 
                1000
            )()
        } catch {
            
        }
    }, [open])

    useEffect(() => {
        _.debounce(() => {
            const shadow = document.querySelector("div[class*='AssetDashboard__Shadow']")
            if (shadow) {
                shadow.parentElement.removeChild(shadow)
            }
        }, 1000)()
    }, [])

    return (
        <DashboardsContainer sidebarOpen={open}>
            <DashboardContainer>
                <AssetDashboard />
            </DashboardContainer>
        </DashboardsContainer>
    )
}

export default DashboardRenderer

const DashboardContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme['dash-background']};
    z-index: 16; /* be above the asset wrench when in expanded mode */

    [class*="AssetDashboard__CloseButton"] {
        display: none;
    }
`
const DashboardsContainer = styled.div<{ sidebarOpen: boolean }>`
    margin-bottom: 30px;
    position: relative;
    height: 100%;
    margin-left: ${props => props.sidebarOpen ? 0 : 32}px;
`